import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Chemburtopunecab() {



  const cardData = {


  keyword: "Chembur to Pune Cab",

  headingDescription: "Trustline Cab provides reliable Chembur to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family trips, railway station transfers, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure punctual pickups, smooth travel via the Mumbai-Pune Expressway, and a comfortable journey from Chembur to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Chembur to Pune taxi services.",

  topPlaces: [
    {
      title: "Kalyani Nagar",
      description: "Kalyani Nagar is one of Pune's premium commercial and residential destinations, featuring corporate offices, IT companies, luxury hotels, shopping malls, restaurants, and modern infrastructure. It is a preferred location for business executives and visitors."
    },
    {
      title: "Baner",
      description: "Baner is a thriving commercial locality known for IT companies, business parks, premium cafés, restaurants, educational institutions, and upscale residential developments. It is one of Pune's fastest-growing corporate hubs."
    },
    {
      title: "Tathawade",
      description: "Tathawade is a rapidly developing suburb offering educational institutions, commercial spaces, residential townships, and excellent connectivity to Wakad, Hinjewadi, and Pimpri Chinchwad."
    },
    {
      title: "Bhosari MIDC",
      description: "Bhosari MIDC is a major industrial zone housing engineering companies, manufacturing units, automobile businesses, warehouses, and logistics centers. It is a key destination for industrial and corporate travel."
    },
    {
      title: "Pimpri Chinchwad",
      description: "Pimpri Chinchwad is one of Maharashtra's largest industrial and commercial regions, known for automobile manufacturing, engineering companies, corporate offices, and modern infrastructure."
    },
    {
      title: "Yerwada",
      description: "Yerwada is an important commercial locality offering business establishments, hotels, hospitals, educational institutions, and excellent connectivity to Pune Airport and central Pune."
    },
    {
      title: "Aga Khan Palace",
      description: "Aga Khan Palace is one of Pune's most iconic historical landmarks, admired for its grand architecture, beautiful gardens, and important role in India's freedom movement. It attracts tourists throughout the year."
    },
    {
      title: "Parvati Hill",
      description: "Parvati Hill is a famous heritage attraction featuring ancient temples, panoramic city views, and peaceful surroundings. It is a favorite destination for sightseeing, photography, and spiritual visits."
    },
    {
      title: "Mulshi Dam",
      description: "Mulshi Dam is a scenic destination surrounded by lush green hills, serene backwaters, and beautiful landscapes. It is a popular weekend getaway for families, couples, and nature enthusiasts."
    },
    {
      title: "Lohagad Fort",
      description: "Lohagad Fort is a historic hill fort near Pune known for its trekking routes, spectacular valley views, rich Maratha history, and stunning monsoon scenery. It is one of the region's most visited trekking destinations."
    }
  ],






"services": [
  {
    "name": "Chembur to Pune Cab Fare",
    "description": "Check Chembur to Pune Cab Fare with transparent pricing, fixed rates, AC vehicles, and professional drivers for comfortable intercity travel."
  },
  {
    "name": "Chembur to Baner Cab Fare",
    "description": "Book Chembur to Baner Cab with affordable fares, doorstep pickup, clean cars, and experienced chauffeurs."
  },
  {
    "name": "Chembur to Pimpri Chinchwad Cab Fare",
    "description": "Reserve Chembur to Pimpri Chinchwad Cab with fixed pricing, comfortable AC vehicles, and safe highway travel."
  },
  {
    "name": "Chembur to Pune Station Cab",
    "description": "Travel from Chembur to Pune Station with reliable taxi service, timely pickup, professional drivers, and comfortable vehicles."
  },
  {
    "name": "Chembur to Pune Shivaji Nagar Cab",
    "description": "Book Chembur to Pune Shivaji Nagar Cab for convenient intercity travel with transparent pricing and well-maintained vehicles."
  },
  {
    "name": "Chembur to Koregaon Park Cab",
    "description": "Choose Chembur to Koregaon Park Cab for safe, affordable, and comfortable travel with experienced chauffeurs."
  },
  {
    "name": "Chembur to Pune Innova Crysta",
    "description": "Hire Chembur to Pune Innova Crysta for premium family, corporate, and group travel with spacious seating and luggage space."
  },
  {
    "name": "Chembur to Pune Sedan Cabs",
    "description": "Book Chembur to Pune Sedan Cabs for economical travel with clean AC cars, professional drivers, and fixed fares."
  },
  {
    "name": "Chembur to Pune Taxi Fare",
    "description": "Check Chembur to Pune Taxi Fare with affordable packages, transparent pricing, and multiple cab options."
  },
  {
    "name": "Chembur to Kharadi Cab Fare",
    "description": "Reserve Chembur to Kharadi Cab with fixed fares, comfortable AC vehicles, and experienced chauffeurs."
  },
  {
    "name": "Chembur to Pune Cab",
    "description": "Book Chembur to Pune Cab for one-way or round-trip travel with Sedan, Ertiga, Innova Crysta, and premium chauffeur-driven vehicles."
  },
  {
    "name": "Chembur to Shivaji Nagar Cab",
    "description": "Choose Chembur to Shivaji Nagar Cab for safe, punctual, and comfortable intercity transportation."
  },
  {
    "name": "Chembur to Pune One Way Cab",
    "description": "Reserve Chembur to Pune One Way Cab with affordable fares, doorstep pickup, and direct drop service."
  },
  {
    "name": "Pune to Sion Taxi Fare",
    "description": "Check Pune to Sion Taxi Fare with transparent pricing, reliable drivers, and comfortable AC cab options."
  },
  {
    "name": "Taxi Service in Chembur Mumbai",
    "description": "Our Taxi Service in Chembur Mumbai provides local and outstation cabs with instant booking, professional chauffeurs, and clean vehicles."
  },
  {
    "name": "Best Taxi Service in Chembur Mumbai",
    "description": "Choose the Best Taxi Service in Chembur Mumbai for reliable rides, premium cars, courteous drivers, and 24x7 support."
  },
  {
    "name": "Best Taxi Service in Chembur Mumbai Contact Number",
    "description": "Contact our Best Taxi Service in Chembur Mumbai for instant bookings, transparent fares, and dependable intercity travel."
  },
  {
    "name": "Chembur to Pune Cab Service",
    "description": "Our Chembur to Pune Cab Service offers comfortable AC vehicles, fixed pricing, professional drivers, and reliable pickup and drop."
  },
  {
    "name": "Chembur to Pune Taxi",
    "description": "Book Chembur to Pune Taxi for affordable, safe, and comfortable travel with clean vehicles and experienced chauffeurs."
  },
  {
    "name": "Chembur to Pune One Way Cab",
    "description": "Travel with Chembur to Pune One Way Cab for hassle-free transportation, fixed fares, and comfortable intercity rides."
  },
  {
    "name": "Chembur to Pune Taxi Booking",
    "description": "Complete Chembur to Pune Taxi Booking online with instant confirmation, secure reservations, and multiple vehicle choices."
  },
  {
    "name": "Chembur to Pune Drop Taxi",
    "description": "Book Chembur to Pune Drop Taxi for direct one-way travel with professional chauffeurs and transparent pricing."
  },
  {
    "name": "Chembur to Pune Online Cab Booking",
    "description": "Reserve Chembur to Pune Online Cab Booking with quick confirmation, affordable fares, and 24x7 booking support."
  },
  {
    "name": "Chembur to Pune Private Cab",
    "description": "Hire Chembur to Pune Private Cab for exclusive chauffeur-driven travel with flexible schedules and premium comfort."
  },
  {
    "name": "Chembur to Pune Outstation Cab",
    "description": "Choose Chembur to Pune Outstation Cab for reliable long-distance travel with AC vehicles and experienced drivers."
  },
  {
    "name": "Chembur to Pune Cheap Cab",
    "description": "Book Chembur to Pune Cheap Cab with economical pricing, clean vehicles, and dependable service."
  },
  {
    "name": "Chembur to Pune AC Cab Service",
    "description": "Travel comfortably with Chembur to Pune AC Cab Service featuring air-conditioned cars and professional chauffeurs."
  },
  {
    "name": "Chembur to Pune Innova Cab",
    "description": "Reserve Chembur to Pune Innova Cab for spacious family travel, corporate trips, and airport transfers."
  },
  {
    "name": "Chembur East to Pune Cab",
    "description": "Book Chembur East to Pune Cab with doorstep pickup, fixed pricing, and comfortable AC vehicles."
  },
  {
    "name": "Chembur West to Pune Cab",
    "description": "Choose Chembur West to Pune Cab for safe, reliable, and affordable intercity travel with professional drivers."
  }
],

"tableData": [
  ["Chembur to Pune Cab Fare", "Chembur to Baner Cab Fare"],
  ["Chembur to Pimpri Chinchwad Cab Fare", "Chembur to Pune Station Cab"],
  ["Chembur to Pune Shivaji Nagar Cab", "Chembur to Koregaon Park Cab"],
  ["Chembur to Pune Innova Crysta", "Chembur to Pune Sedan Cabs"],
  ["Chembur to Pune Taxi Fare", "Chembur to Kharadi Cab Fare"],
  ["Chembur to Pune Cab", "Chembur to Shivaji Nagar Cab"],
  ["Chembur to Pune One Way Cab", "Pune to Sion Taxi Fare"],
  ["Taxi Service in Chembur Mumbai", "Best Taxi Service in Chembur Mumbai"],
  ["Best Taxi Service in Chembur Mumbai Contact Number", "Chembur to Pune Cab Service"],
  ["Chembur to Pune Taxi", "Chembur to Pune Taxi Booking"],
  ["Chembur to Pune Drop Taxi", "Chembur to Pune Online Cab Booking"],
  ["Chembur to Pune Private Cab", "Chembur to Pune Outstation Cab"],
  ["Chembur to Pune Cheap Cab", "Chembur to Pune AC Cab Service"],
  ["Chembur to Pune Innova Cab", "Chembur East to Pune Cab"],
  ["Chembur West to Pune Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Chembur to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab offers dependable Chembur to Pune cab services with experienced chauffeurs, clean vehicles, and comfortable intercity travel for every passenger."
  },
  {
    WhyChooseheading: "Convenient Pickup Across Chembur",
    WhyChoosedescription: "Enjoy doorstep pickup from Chembur East, Chembur West, Diamond Garden, RC Marg, offices, hotels, and residential societies with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Travel",
    WhyChoosedescription: "Our trained drivers ensure a smooth, secure, and punctual journey through the Mumbai–Pune Expressway with excellent route knowledge."
  },
  {
    WhyChooseheading: "Comfortable Fleet for Every Journey",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to match your travel requirements and passenger count."
  },
  {
    WhyChooseheading: "Transparent & Affordable Cab Pricing",
    WhyChoosedescription: "Receive clear fare details before booking with competitive rates and no hidden charges, making your travel planning simple."
  },
  {
    WhyChooseheading: "One Way & Round Trip Booking",
    WhyChoosedescription: "Book one-way cabs, return journeys, or personalized travel packages according to your preferred schedule."
  },
  {
    WhyChooseheading: "Perfect for Corporate & Family Trips",
    WhyChoosedescription: "Our Chembur to Pune cabs are suitable for business meetings, airport transfers, family vacations, educational visits, and personal travel."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Assistance",
    WhyChoosedescription: "Our support team is available round the clock to help you with bookings, vehicle selection, and travel-related assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Chembur to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Chembur to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Chembur to Pune?",
    answer: "Yes, one-way cab services are available with doorstep pickup from Chembur and direct drop anywhere in Pune."
  },
  {
    question: "Do you provide pickup from Chembur East and Chembur West?",
    answer: "Yes, we provide pickup from Chembur East, Chembur West, RC Marg, Diamond Garden, and nearby Mumbai locations."
  },
  {
    question: "Which vehicles are available for Chembur to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable intercity travel."
  },
  {
    question: "Is Chembur to Pune cab service available 24 hours?",
    answer: "Yes, our cab services are available 24/7, allowing you to travel according to your preferred schedule."
  },
  {
    question: "Can I reserve a return cab from Pune to Chembur?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Chembur."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically mentioned in the confirmed booking quotation."
  },
  {
    question: "Should I book my Chembur to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and your preferred pickup time."
  },
  {
    question: "Do you provide Chembur to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are ideal for business meetings, employee transportation, client visits, and regular corporate travel."
  },
  {
    question: "How can I book Chembur to Pune Cab with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback: "Trustline Travels arranged our Chembur to Pune trip with excellent coordination. The driver arrived on time, the vehicle was spotless, and the journey was smooth from beginning to end.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meera Shah",
    feedback: "The booking process was simple, and the travel experience was outstanding. The cab was comfortable, the driver was courteous, and the entire journey to Pune was relaxing and well-managed.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Chembur to Pune Cab",
  "image": "https://www.trustlinetravels.com/assets/images/chembur-to-pune-cab.webp",
  "description":
    "Book Chembur to Pune Cab with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Chembur to Pune, Baner, Pimpri Chinchwad, Pune Railway Station, Shivaji Nagar, Koregaon Park, and all Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/chembur-to-pune-cab"
  }
};



  return (
    <div>
<Helmet>
  <title>Chembur to Pune Cab | One Way Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Chembur to Pune Cab with Trustline Travels for reliable one-way and round-trip taxi services. Travel from Chembur to Pune, Baner, Pimpri Chinchwad, Pune Railway Station, Shivaji Nagar, Koregaon Park, and nearby destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Chembur to pune cab fare, chembur to baner cab fare, chembur to pimpri chinchwad cab fare, chembur to pune station cab, chembur to pune shivaji nagar cab, chembur to koregaon park cab, chembur to pune innova crysta, Chembur to Pune Cab, Chembur Pune Taxi Service, Chembur to Pune Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/116.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Chemburtopunecab;